export const APP_TITLE = "Danone";
export const ROUTER_STATE = "_routerState";
export const CONFIRM = "confirmation";
export const LOGIN_TOKEN = "_LOGIN_TOKEN";
export const MICROSOFT_TOKEN = "_MICROSOFT_TOKEN";
export const CULTURE_INFO = "_CULTURE_INFO";
export const USR_PROFILE = "_USR_PROFILE";
export const USR_MENU = "_USR_MENU";

export const LocalStorageConst = {
  ServerName: "LS_SERVER_NAME",
  ServerPort: "LS_SERVER_PORT",
  Username: "LS_USERNAME",
  Language: "LS_LANGUAGE",
};

export const INVALID = "INVALID";

export const NZLARGE = { span: 4, offset: 4 };
export const NZSMALL = { span: 24, offset: 0 };

export const DT_REQUEST = {
  draw: 0,
  start: 1,
  length: 10,
  order: [],
  columns: [],
  search: {
    value: "",
    regex: false,
  },
};
